<template>
	<div v-bind="c_test_attrs">
		<label class="font-normal">
			<template v-if="c_ctrlParams.alwaysMailing && 0">
				<input type="checkbox" checked onclick="return false;" :title="c_chboxTitle" />
				<!-- если рассылка идёт всегда, то ридонли чекбокс который даже не прибиндили к модели -->
			</template>
			<template v-else>
				<input type="checkbox" :disabled="disabled" v-model="c_value" :title="c_chboxTitle" />
			</template>
		</label>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
import ctrlMixins from './_mixins.js';
import { ctrlParamsForAll } from './_common-stuff.ts';

export default {
	name: 'ctrl_special_editor',
	components: {},
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: 'Рассылка',
		params: {
			mailingList: {
				name: 'Рассылки которые инициируются данным контролом',
				editType: 'mailingListEd',
			},
			checkedByDefault: {
				name: 'Чекбокс отмечен по умолчанию (но снять можно)',
				editType: 'checkbox',
			},
			alwaysMailing: {
				name: 'Рассылка поджигается всегда',
				tip: 'вне зависимости от значения чекбокса "Включить в рассылку". В пользовательских АРМ как правило этот признак должен быть отмечен. В редакторских АРМ простановка этого признака приводит к тому, что поле скрывается (чтобы не рисовать неактивный и отмеченный по умолчанию чекбокс)',
				editType: 'checkbox',
			},
			mailingContentParamColumn: {
				name: 'Колонки, которые попадут в урл формирования письма',
				tip: `<p>Значения этих колонок (они должны быть выведены в АРМ!) будут получены пейджой формирования письма в качестве GET-параметров. В случае типа получателя "из JSON", эти же параметры получит также урл получения подписчиков. Как правило указывается id, соответственно, пейджи получат "&id=12345".</p>
					<p>Передаваемое пейджам значение колонки разрешается особым образом:</p>
					<ul>
						<li>если поле явно передано в запросе к АРМ, значение берётся то, что передано в этом запросе</li>
						<li>если поле не передано в запросе к АРМ (например, id при создании записи), оно вычитывается из БД после create/update</li>
					<ul>`,
				editType: 'stringList', // временно, потом написать кастомный editType выбора колонок
			},
			...ctrlParamsForAll,
		},
	},
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	props: {
		// большая часть пропсов приезжает из ctrlMixins!
		value: {
			default: false,
		},
		disabled: {
			type: Boolean, // PIRS-2-12326 - контрол поджига с буферизацией иногда нужно дизейблить
			default: false,
		},
	},
	data: function () {
		return {};
	},
	computed: {
		c_chboxTitle: function () {
			var ML = this.c_ctrlParams.mailingList;
			if (!ML || ML.length === 0) {
				return ''; // 'Контрол не инициирует не одной рассылки!';
				// на самом деле пустой mailingList говорит только о том,
				// что нет рассылок, которые поджигаются и отправляются НЕМЕДЛЕННО
				// контрол может тупо ставить чекбокс, по которому могут отправляться рассылки ПО РАСПИСАНИЮ
			} else {
				var prefix = this.c_ctrlParams.alwaysMailing
					? 'Безусловно (всегда) инициирует немедленный запуск рассылок: '
					: 'Инициирует немедленный запуск рассылок: ';
				return (
					prefix +
					ML.map(function (val) {
						return val.name + ' (' + (val.mailingTag || val.id) + ')';
					}).join(', ')
				);
			}
		},
	},
	methods: {},
	created: function () {
		if (!this.value && this.$props.field_meta.ctrlParams.checkedByDefault === true) {
			this.c_value = true;
		}
	},
	mounted: function () {},
};
</script>
